import app from './app';

document.addEventListener('DOMContentLoaded', (e) => {
  app();
});
